// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ck.ck.ck.ck.ck.ck-math-preview {
	padding: 8px;
	background-color: hsl(0, 0%, 98%);
	margin-top: 20px;
	margin-top: 20px;
	margin-left: auto;
	margin-right: auto;
	display: block;
	width: fit-content;
	border-radius: 8px;
	box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
	border: 1px rgba(0,0,0,0.3) solid;
}
.ck-math-view .ck.ck.ck.ck.ck.ck-input-text {
	color: white;
	background-color: #4F4F4F;
	min-width: 20px;
	border: none;
	outline: none;
	box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
	font-family: monospace;
	margin-left: auto;
	margin-right: auto;
	display: block;
}

.ck.ck.ck.ck.ck mjx-merror {
	font-size: 14px;
	color: #e64a19;
	background-color: transparent;
}

.ck.ck-math-form {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    flex-wrap: nowrap;
}

.ck.ck.ck.ck.ck.ck-math-balloon {
	box-shadow: none;
    background: none;
    border: none;
}

.ck-math-balloon:before {
	display: none;
}

.ck-math-balloon:after {
	display: none;
}
`, "",{"version":3,"sources":["webpack://./src/ckeditor5-math/mathform.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,iCAAiC;CACjC,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,oEAAoE;CACpE,iCAAiC;AAClC;AACA;CACC,YAAY;CACZ,yBAAyB;CACzB,eAAe;CACf,YAAY;CACZ,aAAa;CACb,oEAAoE;CACpE,sBAAsB;CACtB,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,cAAc;CACd,6BAA6B;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;CACC,gBAAgB;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd","sourcesContent":[".ck.ck.ck.ck.ck.ck-math-preview {\n\tpadding: 8px;\n\tbackground-color: hsl(0, 0%, 98%);\n\tmargin-top: 20px;\n\tmargin-top: 20px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tdisplay: block;\n\twidth: fit-content;\n\tborder-radius: 8px;\n\tbox-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n\tborder: 1px rgba(0,0,0,0.3) solid;\n}\n.ck-math-view .ck.ck.ck.ck.ck.ck-input-text {\n\tcolor: white;\n\tbackground-color: #4F4F4F;\n\tmin-width: 20px;\n\tborder: none;\n\toutline: none;\n\tbox-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n\tfont-family: monospace;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tdisplay: block;\n}\n\n.ck.ck.ck.ck.ck mjx-merror {\n\tfont-size: 14px;\n\tcolor: #e64a19;\n\tbackground-color: transparent;\n}\n\n.ck.ck-math-form {\n    display: flex;\n    align-items: flex-start;\n    flex-direction: row;\n    flex-wrap: nowrap;\n}\n\n.ck.ck.ck.ck.ck.ck-math-balloon {\n\tbox-shadow: none;\n    background: none;\n    border: none;\n}\n\n.ck-math-balloon:before {\n\tdisplay: none;\n}\n\n.ck-math-balloon:after {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
